import { createClient } from '@supabase/supabase-js'

// Supabase configuration
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'http://127.0.0.1:54321'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'your-anon-key'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
})

// OpenArtifacts API configuration
export const OPENARTIFACTS_API_URL =
  import.meta.env.VITE_OPENARTIFACTS_API_URL || 'http://127.0.0.1:54321/functions/v1/api'

export const VITE_APP_URL = import.meta.env.VITE_APP_URL || 'http://localhost:3000'
